export class ContentsDetail {

    constructor() {
        // this.contents_id = null
        this.contents_url = null
        this.thumbnail_url = null
        this.title = null
        this.content = null
        this.isbn = null
        this.authors = null
        this.price = null
        this.sale_price = null
        this.publisher = null
        this.pubdate = null
        this.contents_length = null
        this.created_at = null
        this.updated_at = null
    }
}






